















































































































































































/**
 * NOTE: When using the sync modifier, objects must always be passed with v-bind!
 *  ALl custom validations should evaluate to true to submit form. Invalid = false
 */
import { Component, Mixins } from "vue-property-decorator";
import Billing from "@/components/checkout/forms/Billing.vue";
import Contact from "@/components/checkout/forms/Contact.vue";
import Notes from "@/components/checkout/forms/Notes.vue";
import Payment from "@/components/checkout/forms/Payment.vue";
import Shipping from "@/components/checkout/forms/Shipping.vue";
import AccordionSectionCheckout from "@/components/elements/accordion/AccordionSectionCheckout.vue";
import { Address } from "@/models/address/address";
import {
  ChairOrderRecord,
  Order,
  OrderDetails,
  UmbrellaOrderRecord,
  FreightRequest
} from "@/models/order/order";
import { PaymentMethod, ShippingMethod } from "@/models/order/helpers";
import { EventBus } from "@/event-bus";
import OrderService from "@/services/order_service";
import { GenericError } from "@/services/error_service";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { GlobalGetters } from "@/store/modules/global/types";
import {
  CustomChairOrder,
  CustomUmbrellaOrder,
} from "@/models/configurator/custom_umbrella";
import { ProductType } from "@/models/products/product";
import SaveQuoteModal from "@/components/elements/modal/SaveQuoteModal.vue";
import UIkit from "uikit";
import { Mobile } from "@/mixins/mobile";

@Component({
  components: {
    AccordionSectionCheckout,
    Billing,
    Contact,
    Notes,
    Payment,
    Shipping,
    SaveQuoteModal
  },
})
export default class CheckoutForm extends Mixins(Mobile) {
  @(namespace(StoreModule.Order).Action(OrderActions.AddShipping))
  addShipping!: (value: OrderDetails["shipping_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddBilling))
  addBilling!: (value: OrderDetails["billing_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddPayment))
  addPayment!: (value: OrderDetails["payment_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddContact))
  addContact!: (value: OrderDetails["contact_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddNotes))
  addNotes!: (value: string) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddOrderId))
  addOrderId!: (value: { id: string; creator: string }) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;
  @(namespace(StoreModule.Order).Action(OrderActions.AddCostDetails))
  addCostDetails!: (value: OrderDetails["cost_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  protected orderService = new OrderService();
  protected error = {
    billing: false,
    shipping: false,
    payment: false,
    contact: false,
  };
  protected order: OrderDetails = {
    contact_details: {
      quote_name: "",
      company_name: "",
      contact_name: "",
      phone: "",
      email: "",
    },
    shipping_details: {
      first_name: "",
      last_name: "",
      company_name: "",
      address: {
        country: "USA",
      } as Address,
      phone: "",
      email: "",
      method: ShippingMethod.DropShip,
    },
    billing_details: {
      first_name: "",
      last_name: "",
      company_name: "",
      address: {
        country: "USA",
      } as Address,
      phone: "",
      email: "",
    },
    payment_details: {
      method: PaymentMethod.FullPrepay,
      card: "",
      auth: false,
    },
    notes: "",
  };
  protected newFreight: FreightRequest = {
    addressType: null,
    services: null,
    shippingZip: null,
    requestDate: null,
    updatedDate: null
  };
  protected showFreightModal = false;
  protected showFreightOptions = false;
  protected requestReady = true;

  created(): void {
    this.order = Object.assign({}, { ...this.storeOrder });
  }

  protected switchPanel(index: number): void {
    UIkit.accordion(".acc").toggle(index, true);
  }

  protected setShippingInfo(same: boolean): void {
    if (same) {
      const obj: any = Object.assign(
        {},
        { ...this.order.billing_details! },
        {
          address: this.order.billing_details?.address,
          method: this.order.shipping_details?.method,
        }
      );
      (this.order
        .shipping_details as OrderDetails["shipping_details"]) = Object.assign(
        {},
        { ...obj },
        { address: obj.address }
      ) as any;
    } else {
      this.order.shipping_details = {
        first_name: "",
        last_name: "",
        company_name: "",
        address: {
          country: "USA",
        } as Address,
        phone: "",
        email: "",
        method: ShippingMethod.DropShip,
      };
    }
  }

  protected async goToReview(): Promise<void> {
    EventBus.$emit("submitCheckoutForm");
    let invalid = false;
    for (const value of Object.values(this.error)) {
      if (value) {
        invalid = true;
      }
    }
    if (!invalid) {
      await this.saveDataToStore();
      this.$router.push({
        name: "OrderReview",
        params: {
          order: this.order as any,
        },
      });
    }
  }

  /**
   * Only required validation from contact form
   */
  protected saveQuote(): void {
    EventBus.$emit("saveQuote");
    this.error.billing = false;
    this.error.shipping = false;
    this.error.payment = false;
    if (!this.error.contact) {
      this.toggleSaveQuoteModal();
    }
  }

  protected toggleSaveQuoteModal(): void {
    this.showFreightModal = !this.showFreightModal;
    if (!this.showFreightModal) {
      this.showFreightOptions = false;
      this.requestReady = true;
    }
  }

  protected toggleFreightOptions(): void {
    this.showFreightOptions = !this.showFreightOptions;
  }

  protected updateNewFreight(): void {
    if (
      this.newFreight.addressType &&
      this.newFreight.services &&
      this.newFreight.shippingZip &&
      // Test Zip Code for valid 5 digit numerical type of value for U.S. Zip Codes
      /^\d{5}$/.test(this.newFreight.shippingZip)
    ) {
      this.requestReady = true;
    } else {
      this.requestReady = false;
    }
  }

  protected prepFreightData(): void {
    if (this.requestReady && !this.showFreightOptions) {
      this.showFreightOptions = true;
      this.updateNewFreight();
    } else if (this.requestReady && this.showFreightOptions) {
      this.newFreight.requestDate = new Date();
      this.order.cost_details!.freight_request = this.newFreight;
      this.prepQuoteData();
    }
  }

  protected adminUpdate(): void {    
    if (this.userRole === 'admin' && this.order.cost_details?.shipping !== null && this.order.cost_details?.tax !== null && this.hasOnlyUpdatedDateNull) {      
      this.order.cost_details!.freight_request!.updatedDate = new Date();
    }
  }

  /**
   * Takes the order object that will be saved to the store and assesses if the
   * freight_request property has all non-null values except the updated date.
   */
  get hasOnlyUpdatedDateNull(): boolean {
    return (
      this.order.cost_details!.freight_request!.addressType !== null &&
      this.order.cost_details!.freight_request!.services !== null &&
      this.order.cost_details!.freight_request!.shippingZip !== null &&
      this.order.cost_details!.freight_request!.requestDate !== null &&
      this.order.cost_details!.freight_request!.updatedDate === null
    )
    ? true
    : false;
  }

  protected async saveDataToStore(): Promise<void> {
    await this.addShipping(this.order.shipping_details);
    await this.addBilling(this.order.billing_details);
    await this.addPayment(this.order.payment_details);
    await this.addContact(this.order.contact_details);
    await this.addNotes(this.order.notes);
    await this.addCostDetails(this.order.cost_details);
  }

  protected async prepQuoteData(): Promise<void> {
    try {
      this.adminUpdate();
      await this.saveDataToStore();
      const order = await this.parseItems();
      this.toggleSaveQuoteModal();
      if (this.storeOrder._id) {
        await this.updateQuote(order);
      } else {
        await this.createQuote(order);
      }
    } catch (err) {
      GenericError.popup("Something went wrong.");
    }
  }

  /**
   * The API expects only mfr_codes for fabric swatches. We save the entire fabric swatch object on the frontend because the fabric selector needs the extra data to do filtering
   */
  protected async parseItems(): Promise<Order> {
    const items = JSON.parse(JSON.stringify(this.storeOrder.items!));
    for (const item of items) {
      if (item.product_type === ProductType.Umbrella) {
        const parsedData = this.parseFabricFields(
          (item.item_details as CustomUmbrellaOrder)
            .canopy as CustomUmbrellaOrder["canopy"]
        );
        (item.item_details as CustomUmbrellaOrder).canopy = Object.assign(
          {},
          { ...(item.item_details as CustomUmbrellaOrder).canopy },
          { ...parsedData }
        );
      } else if (item.product_type === ProductType.Chair) {
        const parsedData = this.parseFabricFields(
          item.item_details as CustomChairOrder
        );
        (item.item_details as any) = Object.assign(
          {},
          { ...item.item_details },
          { ...parsedData } as ChairOrderRecord
        );
      }
    }
    const order = { ...this.storeOrder };
    order.items = [...items];
    return order;
  }

  /**
   * API is expecting strings for fabrics. parseFabricFields() convert swatch objects to strings if value is not already a string
   */
  protected parseFabricFields(
    fabric: CustomUmbrellaOrder["canopy"] | CustomChairOrder
  ): UmbrellaOrderRecord | ChairOrderRecord {
    const fabrics = [
      "mainFabric",
      "mainTrimFabric",
      "mainTrimFabricInner",
      "ventTopFabric",
      "ventMiddleFabric",
      "ventTrimFabric",
      "valanceFabric",
      "bindingFabric",
      "ribFabric",
    ];
    const parsed = {} as UmbrellaOrderRecord;
    for (const fabricKey of fabrics) {
      if (fabric[fabricKey] && fabric[fabricKey].mfr_code) {
        parsed[fabricKey] = fabric[fabricKey].mfr_code;
      } else if (
        fabric[fabricKey] &&
        Array.isArray(fabric[fabricKey]) &&
        fabric[fabricKey].length > 0
      ) {
        parsed[fabricKey] = fabric[fabricKey].map((swatch) => {
          if (swatch.mfr_code) {
            return swatch.mfr_code;
          } else {
            return swatch;
          }
        });
      } else {
        parsed[fabricKey] = fabric[fabricKey];
      }
    }
    return parsed;
  }

  protected async createQuote(order: Order): Promise<void> {
    try {
      const quote = await this.orderService.createQuote(order);
      this.$router.push("/checkout/submitted?type=quote");
      await this.addOrderId({ id: quote._id!, creator: quote.creator_id });
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async updateQuote(order: Order): Promise<void> {
    try {
      await this.orderService.updateQuote(this.storeOrder._id!, order);
      this.$router.push("/checkout/submitted?type=quote");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async createOrder(order: Order): Promise<void> {
    try {
      const res = await this.orderService.createOrder(order);
      this.$router.push("/checkout/submitted?type=order");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async convertToOrder(order: Order): Promise<void> {
    try {
      const res = await this.orderService.convertOrderToQuote(
        order._id!,
        order
      );
      this.$router.push("/checkout/submitted?type=order");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected receiveError(
    invalid: boolean,
    component: "billing" | "shipping" | "payment" | "contact"
  ) {
    this.error[component] = invalid;
  }
}
